/*!
 * Copyright (C) Octillion Media LLC 2019
 * All Rights Reserved.
 */
import { createStore } from 'vuex'

import modules from './modules'

const store = createStore({
  modules: {
    ...modules
  },
  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  // https://vuex.vuejs.org/guide/strict.html
  strict: process.env.NODE_ENV !== 'production',
})

export default store



